const formatBooleanSetting = value => {
  if (parseFloat(value)) {
    return 'Sim'
  }

  return 'Não'
}

export default formatBooleanSetting
